import React from 'react';
import PropTypes from 'prop-types';
import '../../YsDialog/YsDialog.scss';
import DialogContainer from './DialogContainer'

class MessageDialog extends React.Component {
    render() {
        const {
            show,
            title,
            content
        } = this.props;
        return (
            <section className={show ? 'dis-show' : 'dis-hide'}>
                <div className="dialog-msg">

                    <p dangerouslySetInnerHTML={{__html: content}}>
                    </p>

                </div>
            </section>
        )
    }
}

MessageDialog.propTypes = {
    title: PropTypes.string,
    show: PropTypes.boolean,
    content: PropTypes.string
};

export default DialogContainer(MessageDialog);



// WEBPACK FOOTER //
// ./src/components/yunshl/Dialog/MessageDialog.js